import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import BankCardsList from "./BankCardsList";

import { batchedApolloClient } from "app/utils/graphQlClients";

type Props = {
  external_reference: string;
  onAuthedBankCardLoadsSet: (authedBankCardLoads: string) => void;
};

export default graphql<any, Props>(
  gql`
    query bankCardQuery($external_reference: ID) {
      user(external_reference: $external_reference) {
        bank_card_changes {
          external_reference
          bin
          status
          created_at
          country_code
          message
          secure3d_requested
          external_reference
          snapmin_url
          payserv_bank_card {
            cardholder_name
          }
          device {
            phone_number
            external_reference
            snapmin_url
          }
        }
      }
    }
  `,
  {
    options: props => ({
      fetchPolicy: "network-only",
      client: batchedApolloClient,
      variables: {
        external_reference: props.external_reference
      }
    })
  }
)(props => (
  <BOGraphQLLoader data={props.data!}>
    <BankCardsList
      onAuthedBankCardLoadsSet={props.onAuthedBankCardLoadsSet}
      bankCardChanges={props.data.user && props.data.user.bank_card_changes}
    />
  </BOGraphQLLoader>
));
